// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2_E-h","header":"Messages_header__1_pTm"};